<template lang="html">
  <span class="mb-5">
    <i class="fr o-010 mdi-48px" :class="'mdi mdi-' + data.icon"></i>
    <!-- <i class="fr fa-4x o-010" :class="data.icon"></i> -->
    <el-page-header @back="$emit('back')" title="" style="color: white !important;margin-top: 12px;">
      <span slot="content" class="w-100">
        <h3><i :class="'mdi mdi-' + data.icon"></i> {{ data.title }}</h3>
      </span>
    </el-page-header>
  </span>
</template>

<script>
export default {
  name: "HeaderComponent",
  props: ["data"],
  data() {
    return {
      sizeFull: '50%'
    };
  },
  computed: {
    sizeRm: function () {
      console.log(this.data);
      return this.data.fullscreen ? '100%' : '28%'
    }
  },
};
</script>

<style>
.edit_class {
  position: fixed;
  top: 40px;
}

/* #el-drawer__title > .el-drawer__header {
  width: var(--size-full); 
} */
</style>
